var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Column(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M35.1,35.1c0.6-0.5,0.9-1.3,0.9-2.1V3c0-0.8-0.3-1.6-0.9-2.1C34.6,0.3,33.8,0,33,0H3 C2.2,0,1.4,0.3,0.9,0.9C0.3,1.4,0,2.2,0,3v30c0,1.6,1.4,3,3,3h30C33.8,36,34.6,35.7,35.1,35.1z M3,33V3h30v30H3z M18.6,8.2v19.6 c0,0.5,0.4,0.8,0.8,0.8h8.4c0.5,0,0.8-0.4,0.8-0.8V8.2c0-0.5-0.4-0.8-0.8-0.8h-8.4C19,7.4,18.6,7.7,18.6,8.2z M7.3,8.2v19.6 c0,0.5,0.4,0.8,0.8,0.8h8.4c0.5,0,0.8-0.4,0.8-0.8V8.2c0-0.5-0.4-0.8-0.8-0.8H8.1C7.7,7.4,7.3,7.7,7.3,8.2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Column);
export default __webpack_public_path__ + "static/media/2 column.bf8faec08ab0eaaa14834b107ad8d72d.svg";
export { ForwardRef as ReactComponent };